import React, {useCallback, useState} from 'react';

import {useEventTracking} from 'src/hooks/useEventTracking';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';


import {LoginLinkGeneratorToolModal} from './login-link-generator-tool.modal';

export const LoginLinkGeneratorTool = () => {
    const [loginLinkGeneratorShown, setLoginLinkGeneratorShown] = useState(false);
    const {loginLinkGeneratorOpen, loginLinkGeneratorDownload} = useEventTracking();

    const openLoginLinkGeneratorModal = useCallback(() => {
        setLoginLinkGeneratorShown(true);
        loginLinkGeneratorOpen();
    }, [setLoginLinkGeneratorShown, loginLinkGeneratorOpen]);

    const closeLoginLinkGeneratorModal = useCallback((success: boolean) => {
        setLoginLinkGeneratorShown(false);
        loginLinkGeneratorDownload({success});
    }, [setLoginLinkGeneratorShown, loginLinkGeneratorDownload]);

    return (
        <>
            <FlatButton
                disabled={false}
                onClick={openLoginLinkGeneratorModal}>
                <strong>
                    Login Link Generator
                </strong>
            </FlatButton>
            <Dialog
                shown={loginLinkGeneratorShown}
                setShown={() => closeLoginLinkGeneratorModal(false)}>
                <LoginLinkGeneratorToolModal onCloseModal={closeLoginLinkGeneratorModal}/>
            </Dialog>
        </>
    );
};
